<template>
  <div>
    <v-menu
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
            min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
                v-model="closingDate"
                label="First Payment Date"
                readonly
                v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="closingDate" @input="menu2 = false"></v-date-picker>
    </v-menu>

    <highcharts :options="chartOptions"></highcharts>
  </div>
</template>

<script>

  export default {
  name: 'Compare',
  data() {
    return {
      closingDate: ((new Date()).getUTCFullYear()
              +'-'
              +(('0'+(Number((new Date()).getUTCMonth())+2)).slice(-2))
              +'-'+('0' + new Date().getUTCDate()).slice(-2))
    }
  },
  props: {
    loanOptions: {
      type: Array,
      required: true
    }
  },
  computed: {
    combinedData: function() {
      return this.loanOptions.map((l)=> {
        var costEachMonth = [];
        console.log(this.closingDate)
        var date = new Date(this.closingDate);
        for (var i = 0; i < l.principalPaidArray.length; i++) {
          var newDate = new Date(date.setMonth(date.getMonth()+1));
          costEachMonth.push([Date.UTC(newDate.getUTCFullYear(),newDate.getMonth(),newDate.getDay()),
            Number(l.principalPaidArray[i])
            + (l.interestPaidArray.length > i ? Number(l.interestPaidArray[i]) : 0)
            + (l.pmiPaidMonthlyArray.length > i ? Number(l.pmiPaidMonthlyArray[i]) : 0)
            + Number(l.closingCost)]
          );
        }
        // console.log(costEachMonth)
        return {
          pointStart: 1,
          type: 'spline',
          name: l.name,
          data: costEachMonth
        };
      });
      // return this.loanOptions.reduce(function (e, l) {
      //     var costEachMonth = [];
      //     var costEachYear = [];
      //     for (var i = 0; i < l.principalPaidArray.length; i++) {
      //         costEachMonth.push(
      //             Number(l.principalPaidArray[i])
      //             + (l.interestPaidArray.length > i ? Number(l.interestPaidArray[i]) : 0)
      //             + (l.pmiPaidMonthlyArray.length > i ? Number(l.pmiPaidMonthlyArray[i]) : 0)
      //             + Number(l.closingCost)
      //         );
      //         if ((1+i)%12 == 0){
      //             costEachYear.push(
      //                 Number(l.principalPaidArray[i])
      //                 + (l.interestPaidArray.length > i ? Number(l.interestPaidArray[i]) : 0)
      //                 + (l.pmiPaidMonthlyArray.length > i ? Number(l.pmiPaidMonthlyArray[i]) : 0)
      //                 + Number(l.closingCost)
      //             );
      //         }
      //     }
      //     // console.log(costEachMonth)
      //     return e.push({
      //         type: 'spline',
      //         visible: false,
      //         name: l.name + "(Monthly)",
      //         data:costEachMonth
      //     }, {
      //         type: 'spline',
      //         name: l.name + '(Yearly)',
      //         data: costEachYear
      //     }) && e;
      // }, []);
    },
    chartOptions: function () {
      return {
        chart: {
            type: 'series',
            zoomType: 'xy',
            //backgroundColor:"#FBFAE4"
        },
        caption: {
          text: 'Drag a rectangle to zoom in.'
        },
        title: {
          text: 'Total Money Given to Lenders by Month'
        },
        subtitle: {
          text: 'Closing Cost + Principle Paid + Interest Paid + PMI Paid'
        },
        xAxis: {
          // title: {
          //     text: 'Month',
          //     align: 'high'
          // },
          type: 'datetime',
          dateTimeLabelFormats: {
            year: '%Y'
          },
          tickInterval: 365 * 24 * 3600 * 1000
        },
        yAxis: {
          min: 0,
          title: {
            text: 'total money ($)'
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px"><b> {point.key} </b></span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                  '<td style="padding:0"><b>{point.y}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true
            },
          }
        },
        series: this.combinedData
      }
    },
  }
}
</script>
